<template>
  <section>
    <div class="title is-3 has-text-primary">
      Missions
    </div>
    <section>
      <b-message v-if="!isBasicInfoComplete && isPageMounted" title="Basic Info Incomplete" type="is-danger" has-icon>
        <p>You cannot sign up for a mission due to basic information missing from your profile.</p>
        <br />
        <p>This information is missing: <strong>{{ basicInfoMissingFields.join( ', ' ) }}</strong></p>
        <button class="button is-primary"
          @click="goToProfile">
          <span>Complete Your Profile</span>
        </button>
      </b-message>
      <b-table
        :data="table.data"
        detailed
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Name" sortable>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="donationFee" label="Donation Fee (Required)" sortable>
            ${{ props.row.donationFee || '0' }}
          </b-table-column>
          <b-table-column field="country" label="Country" sortable>
            {{ props.row.country }}
          </b-table-column>
          <b-table-column field="fromDate" label="Start Date" sortable centered>
            {{ new Date(props.row.fromDate).toLocaleDateString() }}
          </b-table-column>
          <b-table-column field="toDate" label="End Date" sortable centered>
            {{ new Date(props.row.toDate).toLocaleDateString() }}
          </b-table-column>
          <!-- <b-table-column field="status" label="Status" sortable centered>
            <b-tooltip :label="getApplicationStatusTooltip()">
                <span class="status" v-if="props.row.status === 'Has Not Applied'">{{props.row.status}}</span>
                <span class="status yellow" v-if="props.row.status === 'Application Started'">{{props.row.status}}</span>
            </b-tooltip>
            <span class="status green" v-if="props.row.status === 'Application Completed'">{{props.row.status}}</span>
          </b-table-column> -->
          <b-table-column label="Is Basic Profile Complete?">
            <b-tooltip :label="getApplicationStatusTooltip()">
              <b-icon v-if="isBasicInfoComplete"
                icon="check"
                type="is-success"
                size="is-medium">
              </b-icon>
              <b-icon v-if="!isBasicInfoComplete"
                icon="times"
                type="is-danger"
                size="is-medium">
              </b-icon>
            </b-tooltip>
          </b-table-column>
          <b-table-column label="Sign Up">
            <div v-if="props.row.isSignUpEnabled">
              <b-tooltip :label="getApplicationStatusTooltip()">
                  <button v-if="props.row.status === 'Has Not Applied' && isBasicInfoComplete" class="button is-primary"
                    @click="signupForMission(props.row.missionId, props.row.name)">
                    <span>Sign Up</span>
                  </button>
                  <span v-if="!isBasicInfoComplete" class="is-primary">
                    Please Complete Your User Profile First
                  </span>
                  <button v-if="props.row.status === 'Application Started' && isBasicInfoComplete" class="button is-primary"
                    @click="signupForMission(props.row.missionId, props.row.name)">
                    <span>Finish Application</span>
                  </button>
                  <button v-if="props.row.status === 'Application Completed'" class="button is-info"
                    @click="signupForMission(props.row.missionId, props.row.name)">
                    <span>Edit</span>
                  </button>
              </b-tooltip>
            </div>
            <div v-if="!props.row.isSignUpEnabled">
              Sign Up Disabled
            </div>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <h1>Itinerary</h1>
          <table>
            <tr>
              <th>Activity</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
            <tr v-bind:key="activity.name" v-for="activity in props.row.activities">
              <td class="activity-name">{{ activity.name }}</td>
              <td>
                {{ new Date(activity.startDate).toLocaleDateString() }}
              </td>
              <td>
                {{ new Date(activity.endDate).toLocaleDateString() }}
              </td>
            </tr>
          </table>
        </template>
      </b-table>
    </section>
  </section>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';
import BTooltip from 'buefy/src/components/tooltip/Tooltip';
import ApiUtil from '../../utils/ApiUtil';
import InfoPuller from '../../utils/InfoPuller';
import ValidationUtil from '../../utils/ValidationUtil';

export default {
  components: { BTooltip },
  created() {
    this.setIsLoading(true);
  },
  async mounted() {
    const availableMissions = await ApiUtil.getAvailableMissions();
    _.remove(availableMissions, (mission) => {
      return !mission.isVisible;
    });
    const { userId } = await InfoPuller.getUserFromState(this.user);

    const { isComplete, missingFields } = ValidationUtil.verifyUserBasicInfoCompleted(this.user);
    console.log( 'DIS UZER', this.user );
    console.log( 'isComplete', isComplete );
    console.log( 'missingFields', missingFields );

    this.isBasicInfoComplete = isComplete;
    this.basicInfoMissingFields = missingFields;

    const missions = _.map(availableMissions, (mission) => {
      const missionWithSignUpStatus = mission;
      let status = 'Has Not Applied';
      const missionGoer = _.get(mission, `missionGoers.${userId}`, false);
      if (missionGoer && ValidationUtil.verifyMissionSignupFullyCompleted(this.user, mission.missionId, missionGoer)) {
        status = 'Application Completed';
      } else if (missionGoer) {
        status = 'Application Started';
      }

      missionWithSignUpStatus.status = status;

      return missionWithSignUpStatus;
    });

    this.table.data = missions;
    this.setIsLoading(false);
    this.isPageMounted = true;
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  data() {
    return {
      table: {
        data: [],
        selected: null,
      },
      isBasicInfoComplete: false,
      basicInfoMissingFields: [],
      isPageMounted: false,
    };
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    async signupForMission(missionId, missionName) {
      if (!ValidationUtil.isBasicProfileCompleted(this.user)) {
        this.$router.push({
          name: 'profile',
        });
      } else {
        this.$router.push({
          name: 'mission-signup',
          params: { missionId },
          query: { missionName },
        });
      }
    },
    getApplicationStatusTooltip() {
      if (!ValidationUtil.isProfileCompleted(this.user)) {
        return 'Please complete your user profile';
      }
      return 'Please finish your application';
    },
    goToProfile() {
      this.$router.push({ name: 'profile' });
    },
  },
};
</script>


<style lang="scss">
  @import '../../common/colors.scss';

  .activity-name {
    width: 200px;
  }

  h1 {
    font-size: 100%;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .status {
    font-weight: bold;
  }
</style>
